import { render, staticRenderFns } from "./AdminManageMaterials.vue?vue&type=template&id=27123212&"
import script from "./AdminManageMaterials.vue?vue&type=script&lang=js&"
export * from "./AdminManageMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports